import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MaintenanceComponent } from "../modules/maintenance/maintenance.component";
import { MaintenanceGuardService } from "../services/maintenance-guard/maintenance-guard.service";
import { BuilderComponent } from "../modules/builder/builder.component";
import constants from "./constants";
import { HomeComponent } from "../modules/home/home.component";
import { GetStartedComponent } from "../modules/get-started/get-started.component";
import { OauthConnectComponent } from "../modules/oauth-connect/oauth-connect.component";
import { QuestionnaireResolverService } from "../services/questionnaire-resolver/questionnaire-resolver.service";
import { AuthGuardService } from "../services/auth-guard/auth-guard.service";
import { SavedToXrefComponent } from "../modules/saved-to-xref/saved-to-xref.component";
import { SentToEmailComponent } from "../modules/sent-to-email/sent-to-email.component";

const appRoutes: Routes = [
  // Home
  {
    path: "",
    component: HomeComponent,
    data: {
      animation: "HomePage",
      title: "Xref Template Builder | Reference Checking Questionnaires",
      description:
        "Build your reference checking questionnaire following best practices using Xref’s template builder. Make sure you use the right questions.",
    },
  },

  // Get started
  {
    path: constants.APP_ROUTE_PATHS.getStarted,
    component: GetStartedComponent,
    data: {
      title: "Xref Template Builder | Build your reference check questionnaire",
      description:
        "Use Xref’s best practices template builder to build your own reference checking questionnaire based on the role, job title and competencies required for your new hire.",
    },
  },

  // Builder
  {
    path: constants.APP_ROUTE_PATHS.build,
    component: BuilderComponent,
    resolve: {
      questionnaire: QuestionnaireResolverService,
    },
  },

  // Saved to Xref account
  {
    path: constants.APP_ROUTE_PATHS.savedToXref,
    component: SavedToXrefComponent,
    canActivate: [AuthGuardService],
  },

  // Sent to email
  {
    path: constants.APP_ROUTE_PATHS.sentToEmail,
    component: SentToEmailComponent,
    canActivate: [AuthGuardService],
  },

  // Oauth Connect
  {
    path: constants.APP_ROUTE_PATHS.oauthConnect,
    component: OauthConnectComponent,
  },

  // Maintenance Page
  {
    path: constants.APP_ROUTE_PATHS.maintenance,
    component: MaintenanceComponent,
    canActivate: [MaintenanceGuardService],
  },

  // CatchAll
  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {})],
  exports: [RouterModule],
  providers: [MaintenanceGuardService],
})
export class AppRoutingModule {}
